import { combineReducers } from 'redux';

const archivedQuestions = (state = [], action) => {
  switch (action.type) {
    case 'RUN_ARCHIVED_REPORT_FULFILLED':
      return action.payload.data.result;
    case 'RUN_ARCHIVED_REPORT_REJECTED':
      return [];
    default:
      return state;
  }
};

const prescreen = (state = [], action) => {
  switch (action.type) {
    case 'RUN_PRESCREEN_REPORT_FULFILLED':
      return action.payload.data.result;
    case 'RUN_PRESCREEN_REPORT_REJECTED':
      return [];
    default:
      return state;
  }
};
const assessmentByQuestionType = (state = [], action) => {
  switch (action.type) {
    case 'RUN_QUESTION_TYPE_REPORT_FULFILLED':
      return action.payload.data.result;
    case 'RUN_QUESTION_TYPE_REPORT_REJECTED':
      return [];
    default:
      return state;
  }
};

const certificateOnFile = (state = [], action) => {
  switch (action.type) {
    case 'RUN_CERTIFICATE_REPORT_FULFILLED':
      return action.payload.data.assessmentWithCertificate;
    case 'RUN_CERTIFICATE_REPORT_REJECTED':
      return [];
    default:
      return state;
  }
};
const conditionalApprovalComments = (state = [], action) => {
  switch (action.type) {
    case 'RUN_CONDITION_APPROVAL_COMMENTS_REPORT_FULFILLED':
      return action.payload.data.result;
    case 'RUN_CONDITION_APPROVAL_COMMENTS_REPORT_REJECTED':
      return [];
    default:
      return state;
  }
};
const individualRequest = (
  state = {
    vendorRequestResult: [],
    questionnaireResult: [],
    scoreResult: [],
  },
  action
) => {
  switch (action.type) {
    case 'RUN_INDIVIDUAL_REPORT_FULFILLED':
      return action.payload.data;
    case 'RUN_INDIVIDUAL_REPORT_REJECTED':
      return {
        vendorRequestResult: [],
        questionnaireResult: [],
        scoreResult: [],
      };
    default:
      return state;
  }
};
const outstandingAssessments = (state = [], action) => {
  switch (action.type) {
    case 'RUN_OUTSTANDING_ASSESSMENTS_REPORT_FULFILLED':
      return action.payload.data.result;
    case 'RUN_OUTSTANDING_ASSESSMENTS_REPORT_REJECTED':
      return [];
    default:
      return state;
  }
};

const pendingRenewals = (state = [], action) => {
  switch (action.type) {
    case 'RUN_RENEWALS_REPORT_FULFILLED':
      return action.payload.data.result;
    case 'RUN_RENEWALS_REPORT_REJECTED':
      return [];
    default:
      return state;
  }
};

/* We should only ever be fetching one report at a time, so we can safely reuse the same isFetching boolean*/

const isFetching = (state = false, action) => {
  switch (action.type) {
    case 'RUN_ARCHIVED_REPORT_PENDING':
    case 'RUN_INDIVIDUAL_REPORT_PENDING':
    case 'RUN_CONDITION_APPROVAL_COMMENTS_REPORT_PENDING':
    case 'RUN_CERTIFICATE_REPORT_PENDING':
    case 'RUN_RENEWALS_REPORT_PENDING':
    case 'RUN_QUESTION_TYPE_REPORT_PENDING':
    case 'RUN_PRESCREEN_REPORT_PENDING':
    case 'RUN_OUTSTANDING_ASSESSMENTS_REPORT_PENDING':
      return true;
    case 'RUN_ARCHIVED_REPORT_REJECTED':
    case 'RUN_ARCHIVED_REPORT_FULFILLED':
    case 'RUN_INDIVIDUAL_REPORT_FULFILLED':
    case 'RUN_INDIVIDUAL_REPORT_REJECTED':
    case 'RUN_CONDITION_APPROVAL_COMMENTS_REPORT_FULFILLED':
    case 'RUN_CONDITION_APPROVAL_COMMENTS_REPORT_REJECTED':
    case 'RUN_CERTIFICATE_REPORT_REJECTED':
    case 'RUN_CERTIFICATE_REPORT_FULFILLED':
    case 'RUN_RENEWALS_REPORT_REJECTED':
    case 'RUN_RENEWALS_REPORT_FULFILLED':
    case 'RUN_QUESTION_TYPE_REPORT_FULFILLED':
    case 'RUN_QUESTION_TYPE_REPORT_REJECTED':
    case 'RUN_PRESCREEN_REPORT_FULFILLED':
    case 'RUN_PRESCREEN_REPORT_REJECTED':
    case 'RUN_OUTSTANDING_ASSESSMENTS_REPORT_FULFILLED':
    case 'RUN_OUTSTANDING_ASSESSMENTS_REPORT_REJECTED':
      return false;
    default:
      return state;
  }
};

const isLoaded = (state = false, action) => {
  switch (action.type) {
    case 'RUN_ARCHIVED_REPORT_PENDING':
    case 'RUN_CERTIFICATE_REPORT_PENDING':
    case 'RUN_INDIVIDUAL_REPORT_PENDING':
    case 'RUN_CONDITION_APPROVAL_COMMENTS_REPORT_PENDING':
    case 'RUN_RENEWALS_REPORT_PENDING':
    case 'RUN_QUESTION_TYPE_REPORT_PENDING':
    case 'RUN_PRESCREEN_REPORT_PENDING':
    case 'RUN_OUTSTANDING_ASSESSMENTS_REPORT_PENDING':
    case 'RESET_REPORT_STATE':
      return false;
    case 'RUN_ARCHIVED_REPORT_REJECTED':
    case 'RUN_ARCHIVED_REPORT_FULFILLED':
    case 'RUN_INDIVIDUAL_REPORT_FULFILLED':
    case 'RUN_INDIVIDUAL_REPORT_REJECTED':
    case 'RUN_CONDITION_APPROVAL_COMMENTS_REPORT_FULFILLED':
    case 'RUN_CONDITION_APPROVAL_COMMENTS_REPORT_REJECTED':
    case 'RUN_CERTIFICATE_REPORT_REJECTED':
    case 'RUN_CERTIFICATE_REPORT_FULFILLED':
    case 'RUN_RENEWALS_REPORT_FULFILLED':
    case 'RUN_RENEWALS_REPORT_REJECTED':
    case 'RUN_QUESTION_TYPE_REPORT_FULFILLED':
    case 'RUN_QUESTION_TYPE_REPORT_REJECTED':
    case 'RUN_PRESCREEN_REPORT_FULFILLED':
    case 'RUN_PRESCREEN_REPORT_REJECTED':
    case 'RUN_OUTSTANDING_ASSESSMENTS_REPORT_FULFILLED':
    case 'RUN_OUTSTANDING_ASSESSMENTS_REPORT_REJECTED':
      return true;
    default:
      return state;
  }
};

const errorMessage = (state = false, action) => {
  switch (action.type) {
    case 'RUN_ARCHIVED_REPORT_PENDING':
    case 'RUN_INDIVIDUAL_REPORT_PENDING':
    case 'RUN_CERTIFICATE_REPORT_PENDING':
    case 'RUN_RENEWALS_REPORT_PENDING':
    case 'RUN_QUESTIONNAIRE_TYPE_REPORT_PENDING':
    case 'RUN_ARCHIVED_REPORT_FULFILLED':
    case 'RUN_INDIVIDUAL_REPORT_FULFILLED':
    case 'RUN_CONDITION_APPROVAL_COMMENTS_REPORT_FULFILLED':
    case 'RUN_CONDITION_APPROVAL_COMMENTS_REPORT_PENDING':
    case 'RUN_CERTIFICATE_REPORT_FULFILLED':
    case 'RUN_RENEWALS_REPORT_FULFILLED':
    case 'RUN_QUESTION_TYPE_REPORT_FULFILLED':
    case 'RUN_PRESCREEN_REPORT_FULFILLED':
    case 'RUN_PRESCREEN_REPORT_PENDING':
    case 'RUN_OUTSTANDING_ASSESSMENTS_REPORT_FULFILLED':
    case 'RUN_OUTSTANDING_ASSESSMENTS_REPORT_PENDING':
    case 'RESET_REPORT_STATE':
      return false;
    case 'RUN_ARCHIVED_REPORT_REJECTED':
    case 'RUN_INDIVIDUAL_REPORT_REJECTED':
    case 'RUN_CONDITION_APPROVAL_COMMENTS_REPORT_REJECTED':
    case 'RUN_CERTIFICATE_REPORT_REJECTED':
    case 'RUN_RENEWALS_REPORT_REJECTED':
    case 'RUN_QUESTION_TYPE_REPORT_REJECTED':
    case 'RUN_PRESCREEN_REPORT_REJECTED':
    case 'RUN_OUTSTANDING_ASSESSMENTS_REPORT_REJECTED':
      return true;
    default:
      return state;
  }
};

const reports = combineReducers({
  archivedQuestions,
  prescreen,
  assessmentByQuestionType,
  certificateOnFile,
  conditionalApprovalComments,
  individualRequest,
  outstandingAssessments,
  pendingRenewals,
  isFetching,
  isLoaded,
  errorMessage,
});

export default reports;
